import { ICellRendererParams, IHeader } from '@ag-grid-community/core';
import { isGlobalAllHeaderActive } from '../deal-series/deal-series.util';

export type QuantityHeaderRendererParams = ICellRendererParams & {
  editable?: boolean;
  handleAllClicked: () => void;
};

export class QuantityHeaderRenderer implements IHeader {
  private params: QuantityHeaderRendererParams;

  private eGui: HTMLElement;

  private button: HTMLElement;

  init(params: QuantityHeaderRendererParams) {
    // Save params for later use
    this.params = params;

    // Create the header element
    this.eGui = document.createElement('div');
    this.eGui.style.display = 'flex';
    this.eGui.style.gap = '10px';
    this.eGui.style.alignItems = 'center';
    this.eGui.style.width = '100%';
    this.eGui.style.height = '100%';
    this.eGui.style.justifyContent = 'space-between';

    const label = document.createElement('span');
    label.innerText = 'Order Amount ($M)';

    const button = document.createElement('grey-button');
    button.innerText = 'All';
    button.addEventListener('click', () => {
      this.params.handleAllClicked();
    });
    this.button = button;

    if (!this.params.editable) {
      this.button.setAttribute('disabled', '');
    } else {
      this.setButtonActiveState();
      this.eGui.append(button);
    }

    this.eGui.append(label);
  }

  getGui() {
    return this.eGui;
  }

  onColumnResized() {}

  private setButtonActiveState(): void {
    const orders = [];
    this.params.api.forEachNode((row) => {
      if (!row.data?.MATURITY_ID) return;
      orders.push(row.data);
    });
    const active = isGlobalAllHeaderActive(orders);
    if (active) {
      this.button.setAttribute('active', '');
    } else {
      this.button.removeAttribute('active');
    }
  }

  refresh(): boolean {
    // Update disabled state based on editable property
    const isEditable = this.params.editable !== false;
    if (!isEditable) {
      this.button.setAttribute('disabled', '');
    } else {
      this.button.removeAttribute('disabled');
    }
    
    this.setButtonActiveState();
    return true;
  }
}
